import { Directive } from '@angular/core';

@Directive({
  selector: '[appPageLayoutHeader],app-page-layout-header',
  host: {
    class: 'vex-page-layout-header'
  }
})
export class PageLayoutHeaderDirective {

  constructor() { }

}

